import { API_PREFIX } from '@/config/api'
import api from '@/helpers/api'
import { buildQueryUrl } from '../utils/queryUtils'

const getStatistics = (params: any) =>
    api
        .get(`${API_PREFIX}/statistics${buildQueryUrl(params)}`)
        .then(response => Promise.resolve(response.data))

export const statisticService = {
    getStatistics
}
